module.exports = __webpack_public_path__ + "img/google_signin_hover.80527ac6.png";